import TeamForm from "../forms/TeamForm";
import MembersForm from "../forms/MembersForm";
import EventoCalendarioForm from "../forms/EventoCalendarioForm";
import VacacionesForm from "../forms/VacacionesForm";
import ExportCuadernoModal from "../modals/ExportCuadernoModal";
import ExportPdfModal from "../modals/ExportPdfModal";
import IntegrationsModal from "../modals/IntegrationsModal";
import * as api from "../../api";
import { gestionablesPor, esAdmin } from "../../utils";

// El resto de modales con marco: equipos, exportar el cuaderno, eventos del
// calendario, periodos de vacaciones e integraciones. Se pintan dentro del marco
// que pone App; `modal` decide cual toca.

export default function ModalesGenerales({ modal, setModal, inS, lbS, createTeam, updateTeam, users, teams, currentUser, agendaTipos, agendaTiposData, notionItems, agenda, setPdfPreview, calendarios, createEvento, updateEvento, deleteEvento, festivos, createVacacion, updateVacacion, reemplazarVacacion, deleteVacacion, showToast, integrations, token, reloadIntegrations, handleIntegrationSync }) {
  return (
    <>
      {modal==="newTeam"&&<TeamForm inS={inS} lbS={lbS} onSave={d=>{createTeam(d);setModal(null);}} onClose={()=>setModal(null)}/>}
      {modal?.type==="editTeam"&&<TeamForm inS={inS} lbS={lbS} team={modal.team} onSave={d=>{updateTeam(modal.team.id,d);setModal(null);}} onClose={()=>setModal(null)}/>}
      {modal?.type==="modifyMembers"&&<MembersForm allUsers={users} team={modal.team} inS={inS} lbS={lbS} onSave={members=>{updateTeam(modal.team.id,{...modal.team,members});setModal(null);}} onClose={()=>setModal(null)}/>}
      {modal?.type==="exportCuaderno"&&<ExportCuadernoModal agenda={modal.agenda} view={modal.view} currentUser={currentUser} agendaTipos={agendaTipos} agendaTiposData={agendaTiposData} teams={teams} notionItems={notionItems} onClose={()=>setModal(null)}/>}
      {modal?.type==="exportPdf"&&<ExportPdfModal project={null} tasks={[]} agenda={agenda} onClose={()=>setModal(null)} onPreview={(data)=>{setPdfPreview(data);setModal(null);}}/>}
      {modal?.type==="eventoCal"&&(
        <EventoCalendarioForm
          evento={modal.evento||null} calendarios={calendarios}
          defaultDate={modal.fecha||""}
          onSave={async d=>{ if(modal.evento) await updateEvento(modal.evento.id,d); else await createEvento(d); setModal(null); }}
          onDelete={modal.evento?async()=>{await deleteEvento(modal.evento.id);setModal(null);}:null}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="vacacion"&&(
        <VacacionesForm
          periodo={modal.periodo||null} currentUser={currentUser}
          /* Los departamentos que se estan viendo en el calendario, y de
             ellos solo sobre quien se puede escribir de verdad. Se anade
             siempre la persona del periodo que se edita, aunque su
             departamento este desmarcado. El backend lo recomprueba. */
          users={(()=>{
            const base = modal.personas?.length ? modal.personas : users;
            const lista = gestionablesPor(currentUser, base, teams);
            const dueno = modal.periodo && users.find(u=>String(u.id)===String(modal.periodo.user_id));
            return dueno && !lista.some(u=>String(u.id)===String(dueno.id))
              ? [dueno, ...lista] : lista;
          })()}
          isAdmin={esAdmin(currentUser)} festivos={festivos}
          defaultDate={modal.fecha||""}
          onSave={async d=>{ if(modal.periodo) await updateVacacion(modal.periodo.id,d); else await createVacacion(d); setModal(null); }}
          onSolicitado={v=>{reemplazarVacacion(v);setModal(null);showToast("Solicitud enviada a RRHH");}}
          onCrearYSolicitar={async(d,tipoId)=>{
            const v=await createVacacion(d);
            if(!v) return;                       // createVacacion ya avisa del fallo
            setModal(null);
            try{
              reemplazarVacacion(await api.solicitarVacacion(v.id,tipoId));
              showToast("Registrado y solicitado a RRHH");
            }catch(e){
              // El borrador se queda: esta apuntado y se puede reintentar
              // desde el sin volver a escribirlo.
              showToast(e.message||"Registrado, pero la solicitud no salió","warn");
            }
          }}
          onDelete={modal.periodo?async()=>{await deleteVacacion(modal.periodo.id);setModal(null);}:null}
          onClose={()=>setModal(null)}/>
      )}
      {modal==="integrations"&&<IntegrationsModal integrations={integrations} currentUser={currentUser} token={token} onClose={()=>{setModal(null);reloadIntegrations();}} onDisconnect={async(prov)=>{await api.disconnectIntegration(prov);reloadIntegrations();showToast("Integración desconectada");}} onRefresh={reloadIntegrations} onSync={handleIntegrationSync}/>}
    </>
  );
}
